import gql from 'graphql-tag';

export const CREATE_MANUAL_VIEWERSHIP = gql`
  mutation CreateCompleteManualViewership(
    $benSourceId: Int!
    $watchStationId: Int!
    $watchSourceId: Int
    $premiereDate: ISODateTime!
    $premiereImpressions: Int
    $past30Impressions: Int
    $past60Impressions: Int
    $past90Impressions: Int
    $past365Impressions: Int
    $notes: String
  ) {
    createManualViewership(
      payload: {
        benSourceId: $benSourceId
        watchStationId: $watchStationId
        watchSourceId: $watchSourceId
        type: reported
        premiereDate: $premiereDate
        premiereImpressions: $premiereImpressions
        past30Impressions: $past30Impressions
        past60Impressions: $past60Impressions
        past90Impressions: $past90Impressions
        past365Impressions: $past365Impressions
        notes: $notes
      }
    ) {
      id
      benSourceId
      watchSourceId
      watchStationId
      type
      premiereImpressions
      past30Impressions
      past60Impressions
      past90Impressions
      past365Impressions
      createdAt
      updatedAt
      createdBy {
        id
        email
      }
    }
  }
`;
